import CompoundCoursePart from "@/models/CompoundCoursePart";
import CourseRun from "@/models/CourseRun";
import LiveCourseParticipant from "@/models/LiveCourseParticipant";

export default class LiveCourse {
    constructor(raw = {}) {
        this.id = raw.id ?? "-1";
        this.name = raw.name;
        this.courseId = raw.courseId;
        this.courseName = raw.courseName;
        this.participants = raw.participants ? raw.participants.map(part => new LiveCourseParticipant(part)) : [];
    }
}
